import IHeader from "@/interfaces/header";
import Utils from "@/utils";

export default class Header implements IHeader {
  // The constructor
  constructor(data: IHeader) {
    if (data.id) {
      this.setData(data);
    } else {
      this.id = Utils.GenerateUniqueId();
    }
  }

  setData(data: any) {
    if (data.id) {
      this.id = data.id;
    }

    if (data.key) {
      this.key = data.key;
    }

    if (data.value) {
      this.value = data.value;
    }
  }

  // A unique id for
  // this header
  id?: string = "";

  // The header key
  key = "";

  // The actual value of this header
  value = "";

  get isEmpty(): boolean {
    return this.key == "" && this.value == "";
  }

  get formatted() {
    return {
      key: this.key,
      value: this.value,
    };
  }
}
